import React from "react";
import PropTypes from "prop-types";
import { List, Map } from "immutable";
import { Resizable } from "react-resizable";
import { Select, Row, Col,  Modal, Input, message, Upload, Button, Icon } from "antd";
import { Table, BulkCaseActionDropdownCreator } from "components";
import { STATE_STATUS, CASE_ACTION_COL, BUCKET_LIST_DEFAULT_PAGE_SIZE } from "constants";
import "./../styles/inbox-table.css";
import cx from "classnames";
import _lowerCase from "lodash/lowerCase";
import "styles/table.css";
import "styles/inbox.css";
import { StageService } from "services/index";
import QueryString from "query-string";
import { BucketListService } from "../services";
import { getAuthToken } from "../utils";

class InboxCasesTable extends React.Component {
    state = {
        currentPage: 1,
        filters: {},
        currentStageId: this.props.stageId,
        currentStageName: this.props.stage,
        openBulkModal: false,
        bulkCaseTaskIds: [],
        bulkActionRemarks: null,
        containDocuments: true,
        stages: [],
        users: [],
        remarks: null,
        disableForm: true,
        user_id: "",
        openBulkProceedModal: false,
        bulkMoveCasesRemarks: '',
        bulkFileUploaded: false
    };
    pages = [1];
    pageSize = BUCKET_LIST_DEFAULT_PAGE_SIZE;
    
    tableColumns = Map({});
    checkedColumns = List([]);

    BulkDropdown = BulkCaseActionDropdownCreator(
        new Map({
            ASSIGN: this.props.selectedViewType === "Unassigned" ? true : false,
            BULK_PROCEED: this.props.selectedViewType === "assigned" ? true : false
        }),
        this.props.stageId,
        this.props.stage
    );

    componentDidMount() {
        this.fetchCases();
        this.updateColumns({});
    }

    componentDidUpdate(prevProps) {
        this.BulkDropdown = BulkCaseActionDropdownCreator(
            this.props.actionPermissionMap || new Map({}),
            this.props.stageId,
            this.props.stage
        );
        if (
            prevProps.stage !== this.props.stage ||
            (prevProps.currentStage && prevProps.currentStage.key !== this.props.currentStage.key)
        ) {
            this.setState({
                currentPage: 1,
            });
            this.fetchCases();
        } else if(this.props.selectedViewType != prevProps.selectedViewType || this.props.containDocuments != prevProps.containDocuments) {
            this.setState({
                currentPage: 1,
            }, () => this.fetchCases());
            
        }
        this.updateColumns(prevProps);
    }

    getColumnsLocalConfig() {
        let stageCheckedColumns = localStorage.getItem("stageCheckedColumns");
        if(stageCheckedColumns) {
            stageCheckedColumns = JSON.parse(stageCheckedColumns);
        } else {
            stageCheckedColumns = {};
        }
        return stageCheckedColumns;
    }

    updateColumns(prevProps) {
        const columnsLocalConfig = this.getColumnsLocalConfig();
        if(this.tableColumns.size === 0 || prevProps.stage !== this.props.stage || prevProps.selectedViewType !== this.props.selectedViewType) {
            if(this.tableColumns.size === 0 || prevProps.stage !== this.props.stage) {
                this.tableColumns = this.props.columns;
                if(columnsLocalConfig && columnsLocalConfig[this.props.stageId]) {
                    this.tableColumns = this.tableColumns.map((_, key) => {
                        let width = _.width;
                        if(columnsLocalConfig[this.props.stageId] && columnsLocalConfig[this.props.stageId][key] && columnsLocalConfig[this.props.stageId][key].width) {
                            width = columnsLocalConfig[this.props.stageId][key].width;
                        }
                        return ({ 
                            ..._, 
                            width: width
                        });
                    });
                }
            }
            if (this.props.selectedViewType !== "assigned" && this.props.stageId != 17 && !this.props.currentStage.key) {
                this.tableColumns = this.tableColumns.set("actions", {
                    ...CASE_ACTION_COL,
                    render: CASE_ACTION_COL.render(
                        this.props.actionPermissionMap || new Map({}),
                        this.props.stageId,
                        this.props.stage,
                        this.props.user.isUserStageAdmin(Number(this.props.stageId)),
                        this.props.selectedViewType
                    )
                });
            } else {
                this.tableColumns = this.tableColumns.remove("actions");
            }
            const columnsMap =  columnsLocalConfig[this.props.stageId];
            const existingColsList = this.tableColumns.toList().sortBy((a,b) => a.sortIndex > b.sortIndex).map(_ => _.dataIndex);
           
            if(columnsMap) {
                this.checkedColumns = existingColsList.filter(_ => columnsMap[_]);
            } else {
                this.checkedColumns = existingColsList.filter((_, index) => index <= 10);
            }

            if (!["assigned", "hold", "rejected"].includes(this.props.selectedViewType) && this.props.stageId != 17 && !this.props.currentStage.key) { 
                this.checkedColumns = this.checkedColumns.push("actions");
            }
            this.forceUpdate();
        }
    }


    bucketListType(props = this.props) {
        const { stageId, caseStatus, currentStage, selectedViewType } = props;
        const status_type =
            currentStage && currentStage.key ? "PARTICIPATED" : caseStatus;
        let t = "assigned";
        if (selectedViewType !== "assigned") {
            t = _lowerCase(selectedViewType);
        } else if (t === "assigned" && status_type === "PARTICIPATED") {
            t = status_type.toLowerCase();
        }
        if (stageId == 2) t = "all";
        return t;
    }

    isLoading(props) {
        const { cases, caseStatus, stage } = props;
        const k = this.bucketListType(props);
        const s = cases.getIn([caseStatus, stage, k, "status"]);
        return (
            s === STATE_STATUS.FETCHING ||
            s === STATE_STATUS.UNFETCHED ||
            s == null
        );
    }

    
    bulkAssign = (val) => {
        this.setState({
            openBulkModal: true,
            bulkCaseTaskIds: val
        });
        this.updateUserList();
    }
    bulkProceedCases = () => {
        this.setState({
            openBulkProceedModal: true,
        });
    }
    updateUserList = () => {
        StageService.getStages(
            this.props.stageId,
            "assign",
            this.selectedRows[0]
        ).then(({ data }) => {
            const stages = new List(data);
            this.setState(
                {
                    stages,
                    stage: stages.first().id,
                    users: stages.first().user_list,
                    disableForm: false
                }); 
        }).catch(() => {
            this.setState({
                disableForm: false
            });
        });
    }

    fetchCases() {
        const { stageId, stage, caseStatus, currentStage } = this.props;
        let ids =
            currentStage && currentStage.id === 0
                ? JSON.stringify(currentStage.ids)
                : JSON.stringify([stageId]);
        let status_type =
            currentStage && currentStage.key
                ? "PARTICIPATED"
                : caseStatus;
        const type = this.bucketListType();
        let containDocuments = this.props.containDocuments;
        if(containDocuments === "all") {
            containDocuments = null;
        }
        this.props.fetchBucketCases(
            ids,
            type,
            this.state.currentPage,
            this.pageSize,
            stage,
            status_type,
            this.state.filters,
            containDocuments
        );
    }

    onPageChange = (page) => {
        this.setState(
            {
                currentPage: page
            },
            () => {
                if (this.pages.includes(page)) {
                    return;
                }
                this.fetchCases();
            }
        );
    };

    onPageSizeChange = (page, pageSize) => {
        this.setState(
            {
                currentPage: page
            },
            () => {
                this.pages = [page];
                this.pageSize = pageSize;
                this.fetchCases();
            }
        );
    };

    onFilter = values => {
        this.filterObj = {};
        new Map(values).map((_, k) => {
            if(_ && typeof _[0] === "object") {
                if(_[0].max && _[0].max._isAMomentObject) {
                    this.filterObj[k] = JSON.stringify([_[0].min && _[0].min.format("YYYY-MM-DD"), _[0].max && _[0].max.format("YYYY-MM-DD")]);
                }
                else if(_ && _[0].length) {
                    this.filterObj[k] = _ && JSON.stringify(_[0]);
                }
                else {
                    this.filterObj[k] = JSON.stringify([_[0].min, _[0].max]);
                }
            }
            else {
                this.filterObj[k] = _ && _[0];
            }
        });
        this.setState(
            {
                currentPage: 1,
                filters: this.filterObj
            },
            () => this.fetchCases()
        );
    };

    onChangeOption = e => {
        this.props.onViewTypeSelect(e);
    };

    onSelectDocumentFilter = (value) => {
        this.props.onDocumentTypeSelect(value);
    }

    onColumnsUpdate = (columns) => {
        const columnsMap = columns.map(_ => _.toJS()).map(_ => ({ key: _.key, width: _.width })).toJS();
        let stageCheckedColumns = this.getColumnsLocalConfig();
        stageCheckedColumns = {...stageCheckedColumns, [this.props.stageId]: columnsMap };
        localStorage.setItem("stageCheckedColumns", JSON.stringify(stageCheckedColumns));
    }

    getFilterOps() {
        const filterOpts = [];

        if(this.props.stageId !== 17) {
            filterOpts.push({
                value: "assigned",
                label: "My Cases"
            });
        }

        if(
            this.props.currentStage &&
            this.props.stageId !== 17 &&
            !this.props.currentStage.key
        ) {
            filterOpts.push({
                value: "unassigned",
                label: "Unassigned"
            });
        }
        const searchParams = QueryString.parse(this.props.location.search);
        if(
            this.props.user &&
            (this.props.user.stage_admin.includes(this.props.stageId) || (searchParams.stage == "7" && this.props.user?.groups?.find(el=>el.id === 7)))
        ) {
            filterOpts.push({
                value: "all",
                label: "All"
            });
            if(!this.props.currentStage.key) {
                filterOpts.push({
                    value: "hold",
                    label: "Hold"
                }); 
            }
        }

        if(
            this.props.user &&
            this.props.stageId !== 17 &&
            this.props.user.stage_admin.includes(this.props.stageId)
        ) {
            filterOpts.push({
                value: "rejected",
                label: "Rejected"
            }); 
        }

        return (
            <Select
                className={"inbox-table d-flex"}
                onChange={this.onChangeOption}
                value={this.props.selectedViewType}
            >
                {filterOpts.map(_ => <Select.Option key={_.value} value={_.value}>{_.label}</Select.Option>)}
            </Select>
        );
    }

    getPageData() {
        const k = this.bucketListType();
        return this.props.cases.getIn([
            this.props.caseStatus,
            this.props.stage,
            k,
            "data",
            this.state.currentPage
        ]) || List([]);
    }

    shouldShowDocumentFilter() {
        return [5, 9].includes(this.props.stageId) ? true : false;
    }

    openDecisioningDashboard = () => {
        this.props.history.push(`/app/inbox/decision-dashboard/${this.props.stageId}`);
    }
    xlsxAPIDownload = () => {
        this.props.onXlsxDownload({
            stageIds: [this.props.stageId],
            type: this.props.currentStage.key ? "participated" : this.props.selectedViewType
        });
    }

    getCustomButtonVisibility = () => {
        const {currentStage} = this.props;
        if(this.props.stageId == 2) {
            return false;
        }
        if(this.props.user.getIn(["groups"]) && this.props.user.getIn(["groups"]).find(_ => _.id === 31)){
            return true;
        } else {
            if(currentStage && !currentStage.key && this.props.permissions.get("decisioning_dashboard")){
                return true;
            }
            return false;
        }
    }

    getBulkActions = () => {
        if(this.props.selectedViewType === "unassigned" || this.props.selectedViewType == 'all') {
            return ["Assign"];
        }
        if(this.props.stageId == 2) {
            return ["Approve"];
        }
        return [];
    }

    isBulkActionBtnVisible = () => {
        const { stageId, caseStatus, currentStage } = this.props;
        let status_type =
            currentStage && currentStage.key
                ? "PARTICIPATED"
                : caseStatus;
        if(this.props.selectedViewType === "unassigned" || this.props.selectedViewType == 'all') {
            return true;
        }
        if(
            status_type === "INBOX" &&
            stageId === 2
        ) {
            return true;
        }
        return false;
    }

    onSelectRows = (rows) => {
        this.selectedRows = rows && rows.toArray();
    } 

    bulkProceed = (val) => {
        this.props.history.replace(this.props.location.pathname, {
            ...this.props.location.state,
            case_actions: {
                page: this.state.currentPage,
                pageSize: this.pageSize,
                filters: this.filterObj,
                case_ids: this.selectedRows,
                case_id: this.selectedRows[0],
                case_task_ids: val,
                stage_id: this.props.stageId,
                stage_name: this.props.stage,
                current_stage: this.props.stage,
                action: "PROCEED_BULK_CASES",
                params: this.props.location.pathname,
            }
        });
    }

    getBulkActionFunc = () => {
        if(this.props.selectedViewType === "unassigned" || this.props.selectedViewType == 'all') {
            return [ids => this.bulkAssign(ids)];
        } else if(this.props.selectedViewType === "assigned") {
            return [ids => this.bulkProceed(ids)];
        }
        return [];
    }

    onSelectUser = (val) => {
        this.setState({
            user_id: val,
        });
    }
    
    render() {
        const {
            cases,
            caseStatus,
            stage,
            editable
        } = this.props;
        if (!this.BulkDropdown && this.props.actionPermissionMap) {
            this.BulkDropdown = BulkCaseActionDropdownCreator(
                this.props.actionPermissionMap || new Map({}),
                this.props.stageId,
                this.props.stage
            );
        }
        const Ops = this.props.stageId == 2 ? null : this.getFilterOps();
        return (
            <React.Fragment>
                <Modal
                    title={"Proceed"}
                    visible={this.state.openBulkProceedModal}
                    closable={true}
                    destroyOnClose={true}
                    onOk={() => {
                        if((this.props.stageId === 54 && this.state.bulkFileUploaded == true) || this.props.stageId === 8){
                            const body= {
                                case_ids: this.selectedRows,
                                remarks: this.state.bulkMoveCasesRemarks,
                                stageId: this.props.stageId
                            }
                            BucketListService.bulkMoveCases(body).then(res=>{
                                this.setState({
                                    openBulkProceedModal: false
                                })
                                if(res?.status == 200){
                                    message.success(res?.data?.message || "Cases Moved")
                                    setTimeout(() => {
                                        this.fetchCases();
                                    }, 1000);
                                }
                            }).catch((err) => {
                                this.setState({
                                    openBulkProceedModal: false
                                })
                            });
                        }else{
                            message.error("Please upload the file");
                        }
                    }}
                    onCancel={() => {
                        this.setState({
                            openBulkProceedModal: false  
                        });
                    }}
                >{this.props.stageId === 54 &&
                    <Col span={12} className={"p-5"}>
                    <Upload
                            action={null}
                            disabled={this.state.loading}
                            onChange={({ file }) => {
                                if (file.status === "uploading" && !this.state.loading) {
                                    this.setState({
                                        loading: true
                                    })
                                    message.loading("File Uploading")
                                }
                                if (file.status === "done") {
                                    message.success("Successfully Approved")
                                    // this.fetchApprovalDetails();
                                    this.setState({
                                        loading: false,
                                        bulkFileUploaded: true
                                    })

                                }
                                if (file.status === "error") {
                                    this.setState({
                                        loading: false
                                    })
                                    message.destroy();
                                    message.error("Failed to Upload file");
                                }
                            }
                            }
                            {...{
                                directory: false, // Upload Directory Support
                                multiple: false, // Upload Multiple files support,
                                action:
                                    `${process.env.BASE_URL}/case/approval/by-approver/`,
                                showUploadList: false,
                                headers: {
                                    Authorization: `Bearer ${getAuthToken().authToken}`
                                },
                                data: file => ({
                                    document: file,
                                    status: "Approved",
                                    approver_for_email: "pallavi@progfin.com",
                                    case_ids: this.selectedRows
                                }),
                            }}
                        >
                            <Button className="button-squeeze">
                                <Icon type="upload" /> Upload
                            </Button>
                        </Upload>
                    </Col>
                }
                 <Col span={this.props.stageId === 54 ? 12 : 24} className={"p-5"}>
                     <Input.TextArea placeholder={"Remarks"} onChange={(e)=>this.setState({bulkMoveCasesRemarks:e.target.value})} autosize={{minRows:2, maxRows: 3}} />
                 </Col>
                </Modal>
                <Modal
                    title={"Assign"}
                    visible={this.state.openBulkModal}
                    closable={true}
                    destroyOnClose={true}
                    onOk={() => {
                        this.setState({
                            openBulkModal: false
                        }, () => {
                            this.props.bulkAssignBucketCases(
                                this.state.bulkCaseTaskIds,
                                this.state.user_id,
                                this.state.remarks,
                                this.props.stageId,
                                this.props.stage,
                            );
                        });
                    }}
                    onCancel={() => {
                        this.setState({
                            openBulkModal: false  
                        });
                    }}
                >
                    <Select
                        style={{
                            width: "100%"
                        }}
                        placeholder={"Select a User"}
                        showSearch
                        onSelect={this.onSelectUser}
                        filterOption={(input, option) =>(
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        )}
                    >
                        {this.state.users.map(_ => (
                            <Select.Option key={_.id} value={_.id}>
                                {_.full_name}
                            </Select.Option>
                        ))}
                    </Select>
                </Modal>
                <Row className={"inbox-cases-table-row"}>
                    <Col className={"inbox-cases-table-col"}>
                        <Table
                            type={"inner"}
                            title={Ops}
                            columns={this.tableColumns}
                            className= {cx("padless-table", "inbox-table")}
                            checkedColumns={this.checkedColumns.toArray()}
                            data={this.getPageData()}
                            keyFilter={"id"}
                            bulkAction={this.getBulkActionFunc()}
                            bulkProceedCasesAction={[8, 54].includes(this.props.stageId)}
                            bulkProceedCasesModal={this.bulkProceedCases}
                            bulkActionName={this.getBulkActions()}
                            showBulkActionBtn={this.isBulkActionBtnVisible()}
                            ignoreKeyFilter={false}
                            showBulkDropdown={false}
                            showXlsxBtn={true}
                            showAssetsBtn={false}
                            showCustomButton={this.getCustomButtonVisibility()}
                            onCustomButtonClicks={[this.openDecisioningDashboard]}
                            customButtonTexts={["Decisioning"]}
                            custonButtonIcons={["eye"]}
                            showTitle={true}
                            showFilters={true}
                            onRowSelection={this.onSelectRows}
                            showDocumentFilter={this.shouldShowDocumentFilter()}
                            onSelectDocumentFilter={this.onSelectDocumentFilter}
                            containDocuments={this.props.containDocuments}
                            spanConfig={{
                                title: 2,
                                filters: 10,
                                btnSpan: 12
                            }}
                            fixedColsLeft={this.props.stageId == 2 ? ["anchor_name", "id", "buyer_name"] : ["id", "buyer_name"]}
                            fixedColsRight={["actions"]}
                            loading={this.isLoading(this.props)}
                            size={"small"}
                            editable={editable}
                            showFooter={false}
                            showTotalPages={true}
                            tablePagination={false}
                            footer={null}
                            showPaginationOnly={false}
                            // pagination={false}
                            // totalPagesView={{
                            //     currentPage: this.state.currentPage,
                            //     pageSize: this.pageSize,
                            //     totalCases: cases.getIn([caseStatus, stage, "count"])
                            // }}
                            bulkActionSelectedKey={"case_task_id"}
                            pagination={{
                                current: this.state.currentPage,
                                showSizeChanger: true,
                                defaultPageSize: 15,
                                pageSizeOptions: [
                                    "15",
                                    "20",
                                    "50",
                                    "100",
                                    "500"
                                ],
                                position: "bottom",
                                total: cases.getIn([caseStatus, stage, this.bucketListType(), "count"]),
                                onChange: (page, pageSize) =>
                                    this.onPageChange(page, pageSize),
                                onShowSizeChange: this.onPageSizeChange,
                                showTotal:(total, range) => `Showing ${range[0]}-${range[1]} of ${total} items`
                            }}
                            onFilter={this.onFilter}
                            scrollY={true}
                            components={{
                                header: {
                                    cell: ResizeableTitle
                                }
                            }}
                            columnLimit={10}
                            onColumnsUpdate={this.onColumnsUpdate}
                            showApiXlsxDownload={false}
                            onApiXlsxDownload={this.xlsxAPIDownload}
                        />
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}

class ResizeableTitle extends React.Component {
    width = this.props.width;
    componentDidUpdate(prevProps) {
        if(prevProps.width != this.props.width) {
            this.width = this.props.width;
        }
    }
    onResize = (e, { size }) => {
        this.width = size.width;
        this.forceUpdate();    
        this.props.onResize(e, { size });
    } 
    render() {
        const { onResizeEnd, children, onClick, ...restProps } = this.props;
        if (!this.width) {
            return <th {...{...restProps, children: children}} />;
        }

        const baseChild = children[0];
        return (
            <Resizable
                width={this.width}
                height={0}
                onResizeStop={onResizeEnd}
                onResize={this.onResize}
                draggableOpts={{ enableUserSelectHack: false }}
            >
                <th 
                    {...restProps} 
                    style={{ 
                        borderLeft: "1px solid #fafafa", 
                        borderRight: "1px solid #fafafa"
                    }}
                >
                    {<baseChild.type {...baseChild.props}  onClick={onClick}/>}
                    {children[1]}
                </th>
            </Resizable>
        );
    }
}






ResizeableTitle.propTypes = {
    onResizeEnd: PropTypes.func,
    onResize: PropTypes.func,
    width: PropTypes.number,
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    onClick: PropTypes.func
};


InboxCasesTable.propTypes = {
    permissions: PropTypes.object,
    user: PropTypes.object,
    caseStatus: PropTypes.string,
    stage: PropTypes.string,
    stageId: PropTypes.number,
    stagesStatus: PropTypes.string,
    cases: PropTypes.object,
    caseCount: PropTypes.object,
    caseCountStatus: PropTypes.string,
    fetchBucketCases: PropTypes.func,
    myInboxStages: PropTypes.array,
    columns: PropTypes.object,
    size: PropTypes.string,
    editable: PropTypes.bool,
    actionPermissionMap: PropTypes.object,
    currentStage: PropTypes.object,
    selectedViewType: PropTypes.string,
    participatedCaseCount: PropTypes.object,
    toggleHelp: PropTypes.bool,
    bulkAssignBucketCases: PropTypes.func,
    onViewTypeSelect: PropTypes.func,
    containDocuments: PropTypes.string,
    history: PropTypes.object,
    onDocumentTypeSelect: PropTypes.func,
    onXlsxDownload: PropTypes.func,
    fetchStageCase: PropTypes.func,
    location: PropTypes.object
};

export default InboxCasesTable;
